<template>
  <div id="app">
    <el-container id="container-box" v-if="$store.state.isLogin">
      <el-header>
        <Navbar @aiOpen="Aiopen" />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <footer class="fix-to-bottom">
        <div class="mundb-footer">
          <span class="footer-text">Copyright@2015-2024</span>
          <span class="footer-text">备案号：京ICP备17070826号-5</span>
        </div>
      </footer>
      <transition name="el-zoom-in-bottom">
        <div id="person-icon" class="hvr-pulse" v-show="!flag" ref="personicon" @click="Aiopen">
          <img class="ai-zj" src="https://file.magaoedu.com/fad5de0ee8c6ecffbe1dad0bb26d0a4b.png" />
          <span>码小高</span>
        </div>
      </transition>
      <transition name="el-zoom-in-bottom" style="z-index: 1000">
        <!-- drag -->
        <div :id="fullScreen ? 'popup-box-content-fullScreen' : 'popup-box-content'" v-show="flag">
          <div id="popup-box-guide">
            <div class="app-example">
              <div style="color: #000; font-size: 18px; font-weight: bold"><span>示 例</span></div>
            </div>
            <div class="app-exaMain">
              <template>
                <el-carousel :interval="5000" arrow="never">
                  <el-carousel-item v-for="item in imageList" :key="item">
                    <img class="app-img" :src="item" />
                  </el-carousel-item>
                </el-carousel>
              </template>
            </div>
          </div>
          <div :id="fullScreen ? 'popup-box-data-fullScreen' : 'popup-box-data'" ref="popupdata">
            <div class="app-close">
              <div></div>
              <div :class="fullScreen ? 'popup-box-title-fullScreen' : 'popup-box-title'">
                <span style="margin-top: 4px">码小高</span>
                <span style="display: block; font-size: 12px; font-weight: normal; color: #717070"> 本功能由 OPEN AI GPT-3.5-Turbo 驱动 </span>
              </div>
              <div>
                <el-button type="text" style="margin-right: 10px; font-size: 16px; font-weight: bold" @click="changeFullScreen">{{ fullScreen ? "退出全屏" : "全屏" }}</el-button>
                <el-button style="margin-right: 10px; font-size: 16px; font-weight: bold" @click="flag = false">关闭</el-button>
              </div>
            </div>
            <div :class="fullScreen ? 'app-main-fullScreen' : 'app-main'">
              <!-- <iframe src="http://192.168.1.195:8081/?isWendao=1#/chat" width="100%" height="100%" frameborder="0" ref="iframe"></iframe> -->
              <iframe src="https://schoolai.magaoedu.com/?isWendao=1#/chat" width="100%" height="100%" frameborder="0" ref="iframe"></iframe>
            </div>
          </div>
        </div>
      </transition>
    </el-container>
    <transition name="el-fade-in-linear">
      <Login v-if="!$store.state.isLogin"></Login>
    </transition>
    <el-dialog class="rechargeDialog" :close-on-click-modal="false" title="充值" center width="640px" :visible.sync="rechargeShow" @close="closeRecharge">
      <div class="amountArea">
        <div>
          <el-radio-group class="radioLayout" v-model="checkAmount" width="100%" @input="radioChange">
            <el-radio-button label="149">
              <div class="month">1个月</div>
              <div class="amount"><span style="font-size: 14px">￥</span>149</div>
              <div class="realAmount">￥0</div>
              <div class="lackAmount">立省0元</div>
            </el-radio-button>
            <el-radio-button label="410">
              <div class="month">3个月</div>
              <div class="amount"><span style="font-size: 14px">￥</span>410</div>
              <div class="realAmount">￥447</div>
              <div class="lackAmount">立省37元</div>
            </el-radio-button>
            <el-radio-button label="1490">
              <div class="month">1年</div>
              <div class="amount"><span style="font-size: 14px">￥</span>1490</div>
              <div class="realAmount">￥1788</div>
              <div class="lackAmount">立省298元</div>
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="recharge-area">
          <div class="qrcode">
            <img :src="payImg" v-show="payImg != ''" />
          </div>
          <div class="actual-payment">
            <div style="padding-left: 4px; color: #110b01">
              实付: <span>￥{{ checkAmount }}</span>
            </div>
            <div class="wx-svg">
              <svg class="icon" style="width: 40px; height: 40px; vertical-align: middle; fill: currentColor; overflow: hidden" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4221">
                <path
                  d="M814.933333 914.666667H214.4c-54.933333 0-99.733333-44.8-99.733333-99.733334V214.4c0-54.933333 44.8-99.733333 99.733333-99.733333h600.533333c54.933333 0 99.733333 44.8 99.733334 99.733333v600.533333c0 54.933333-44.8 99.733333-99.733334 99.733334z"
                  fill="#3FCF77"
                  p-id="4222"
                ></path>
                <path
                  d="M533.333333 602.666667c0 56-57.066667 101.333333-128 101.333333-14.933333 0-28.8-2.133333-42.133333-5.866667-6.4-1.6-37.333333 24-43.2 21.866667-6.4-2.666667 11.2-34.666667 5.333333-37.866667-29.333333-18.666667-48-46.933333-48-79.466666 0-56 57.066667-101.333333 128-101.333334s128 45.333333 128 101.333334z"
                  fill="#8CE2AD"
                  p-id="4223"
                ></path>
                <path
                  d="M746.666667 493.333333c0 54.4-32 102.4-81.066667 132.266667-8 4.8 26.133333 53.333333 17.066667 57.066667-8.533333 3.733333-60.266667-37.333333-69.866667-34.666667-19.2 5.333333-39.466667 8-60.8 8C444.266667 656 357.333333 582.933333 357.333333 493.333333S444.266667 330.666667 552 330.666667 746.666667 403.733333 746.666667 493.333333z"
                  fill="#FFFFFF"
                  p-id="4224"
                ></path>
                <path d="M485.333333 464m-21.333333 0a21.333333 21.333333 0 1 0 42.666667 0 21.333333 21.333333 0 1 0-42.666667 0Z" fill="#3FCF77" p-id="4225"></path>
                <path d="M357.333333 581.333333m-14.933333 0a14.933333 14.933333 0 1 0 29.866667 0 14.933333 14.933333 0 1 0-29.866667 0Z" fill="#3FCF77" p-id="4226"></path>
                <path d="M618.666667 464m-21.333334 0a21.333333 21.333333 0 1 0 42.666667 0 21.333333 21.333333 0 1 0-42.666667 0Z" fill="#3FCF77" p-id="4227"></path>
              </svg>
              <span style="font-size: 16px; color: #000; font-weight: 400; padding-left: 10px">微信扫码支付</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 0px; font-size: 14px; letter-spacing: 0.06em; line-height: 20px; text-align: justify">
          码小高，是码高教育基于OPEN AI GPT-3.5-Turbo模型，研发的人工智能 AI
          助教，具有出色的上下文理解能力和用户指令理解能力。码小高具备快速的反应力，能够在第一时间为学生提供帮助。同时，码小高还具备引导式对话功能，在回答问题的过程中，能够分步引导学生进行独立思考，而不是直接给出答案，从而锻炼提升学生的逻辑思维能力和解决问题的能力。
        </div>
      </div>
    </el-dialog>
    <el-dialog title="支付成功" :close-on-click-modal="false" :close-on-press-escape="false" class="pay-dialog" center :visible.sync="successFlag" width="300px">
      <el-row>
        <el-col>
          <el-result class="pay-result" icon="success" title="微信充值成功" subTitle="">
            <template slot="extra">
              <el-button type="primary" size="medium" @click="successFlag = false" style="margin-top: 20px">确认</el-button>
            </template>
          </el-result>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Login from "./views/Login.vue";
import Navbar from "./components/Navbar.vue";
window.sources = null;
import axios from "axios";
const CancelToken = axios.CancelToken;
window.sources = CancelToken.source();
export default {
  name: "app",
  components: {
    Login,
    Navbar,
  },
  watch: {
    "$store.state.isLogin"(newVal, oldVal) {
      //对数据执行操作
      this.flag = false;
      this.rechargeShow = false;
      this.dialogVisible = false;
      this.checkAmount = 1490;
    },
  },
  data() {
    return {
      fullScreen: false,
      rechargeTimer: null,
      times: 0,
      isLogin: false,
      flag: false,
      redirect: "",
      remaining: 0,
      unitPrice: 0,
      aiFlag: 1,
      validityDay: "",
      rechargeShow: false,
      checkAmount: 1490,
      dialogVisible: false,
      payImg: "",
      successFlag: false,
      logInfo: {},
      imageList: ["https://file.magaoedu.com/43869e0bc52030d57c76794ca74cd288.jpg", "https://file.magaoedu.com/aa24646b36885cc1e1b7b276725a1d94.jpg", "https://file.magaoedu.com/97693da9e52c689323d2d09f63ea3fbf.jpg"],
    };
  },
  methods: {
    Aiopen() {
      this.logInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.flag = true;
      this.$modal.show("example");
      this.getRemain();
    },

    changeFullScreen() {
      this.fullScreen = !this.fullScreen;
    },

    initTimer() {
      if (this.rechargeTimer != null) {
        clearInterval(this.rechargeTimer);
        this.rechargeTimer = null;
        this.times = 0;
      }
    },

    radioChange() {
      this.initTimer();
      this.openQrbox();
    },

    // 充值
    openQrbox() {
      let day = this.checkAmount == 149 ? 30 : this.checkAmount == 410 ? 90 : 365;
      let _this = this;
      this.dialogVisible = true;
      let postData = {
        token: this.$store.state.token,
        identity: this.logInfo.isShow,
        studentId: this.logInfo.id,
        amount: this.checkAmount,
        day,
      };
      this.$axios.post(this.$API.aiUnifiedOrder, this.$todo.formData(postData)).then((res) => {
        if (res.status && res.status == 500) {
          _this.$message.warning("请重新选择充值金额");
        } else {
          _this.payImg = res;
          _this.payIsComplete(res);
        }
      });
    },

    // 取消充值
    beforeClose(done) {
      this.$confirm("是否放弃本次支付, 是否继续?", "支付未完成", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          done();
          this.rechargeShow = false;
        })
        .catch(() => {});
    },

    closeRecharge() {
      this.checkAmount = 1490;
      this.initTimer();
    },

    // 轮询一下
    payIsComplete(data) {
      let _this = this;
      this.initTimer();
      this.rechargeTimer = setInterval(() => {
        data = _this.payImg;
        if (data) {
          let length = data.split("/");
          let id = data.split("/")[length.length - 1];
          _this.$axios
            .post(
              _this.$API.tradeQuery,
              _this.$todo.formData(
                {
                  outTradeNo: id,
                },
                {
                  cancelToken: window.sources.token,
                }
              )
            )
            .then((res) => {
              if (res.status == 200) {
                _this.initTimer();
                _this.dialogVisible = false;
                _this.rechargeShow = false;
                _this.checkAmount = 1490;
                _this.successFlag = true;
                _this.getRemain();
              } else {
                if (_this.times > 3000) {
                  _this.initTimer();
                  _this
                    .$confirm("支付未完成，是否继续支付?", "支付未完成", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                    .then(() => {
                      _this.openQrbox();
                    })
                    .catch(() => {
                      _this.dialogVisible = false;
                      _this.rechargeShow = false;
                      _this.checkAmount = 1490;
                    });
                } else {
                  _this.times++;
                }
              }
            });
        }
      }, 2000);
    },
    // 获取余额
    getRemain() {
      let postData = {
        studentId: this.logInfo.id,
        identity: this.logInfo.isShow,
      };
      this.$axios
        .post(this.$API.balance, this.$todo.formData(postData))
        .then((res) => {
          this.remaining = res.data.balance;
          this.aiFlag = res.data.flag;
          this.unitPrice = Number(res.data.aiUnitPrice);
          this.validityDay = res.data.endTime.split("T")[0];
          this.sendMessage();
        })
        .catch((error) => {});
    },

    // 计算余额
    caculateRemaining(mount) {
      let currentCost = mount * this.unitPrice;
      let remain = this.remaining - currentCost;
      return remain;
    },

    // 同步余额到Ai助手
    sendMessage() {
      let _this = this;
      const mapFrame = this.$refs["iframe"];
      console.dir(mapFrame)
      if (mapFrame && mapFrame.contentWindow) {
        const iframeWin = mapFrame.contentWindow;
      console.dir(iframeWin)
        
        iframeWin.postMessage(
          {
            type: 1,
            remain: _this.remaining,
            validityDay: _this.validityDay,
            flag: _this.aiFlag,
          },
          "*"
        );
      }
    },

    // 保存记录
    saveRecord(type, details) {
      const charNumber = details.length;
      const usageAmount = details.length * this.unitPrice;
      this.remaining = this.caculateRemaining(details.length).toFixed(6);
      if (this.remaining <= 0) {
        this.aiFlag = 2;
      }
      this.sendMessage();
      let postData = {
        studentId: this.logInfo.id,
        identity: this.logInfo.isShow,
        type, // 0提问1回复',
        details,
        charNumber, //字符数
        usageAmount: usageAmount.toFixed(6), // 使用金额
        remainingAmount: this.remaining, // 剩余金额
      };
      this.$axios
        .post(this.$API.saveUsage, this.$todo.formData(postData))
        .then((res) => {})
        .catch((error) => {});
    },

    // 充值
    recharge() {
      this.rechargeShow = true;
      this.openQrbox();
    },
  },
  mounted() {
    let _this = this;
    window.addEventListener(
      "message",
      function (e) {
        if (e.data) {
          if (e.data.type == 0 || e.data.type == 1) {
            _this.saveRecord(e.data.type, e.data.msg);
          } else if (e.data.type == 2) {
            _this.recharge();
          }
        }
      },
      false
    );
    if (this.$todo.getCookie("token")) {
      this.$store.commit("updateToken", true);
      this.$store.commit("setToken", this.$todo.getCookie("token"));
    } else {
      this.$store.commit("updateToken", false);
    }
    this.$nextTick(() => {
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) {
          this.flag = false;
        }
      });
    });
  },
  beforeDestroy() {
    this.flag = false;
  },
};
</script>
<style>
::-webkit-scrollbar {
  width: 5px;
  height: 6px;
  background: none;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 16px rgb(186, 172, 172);
}
</style>
<style scoped>
.footer-text {
  margin: 0 20px;
}
.ai-zj {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}
.stepsToGuide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

footer {
  color: #555 !important;
  background-color: #fff;
  text-align: center;
  background-color: #ffff;
}

footer a {
  color: #555;
}

footer a:hover {
  color: #409eff;
  text-decoration: none;
}
footer h1 {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  font-weight: 300;
  color: #3d3d3d;
  line-height: 1.1;
  font-size: 1.5rem;
}

.mundb-footer {
  padding: 38px 0;
  width: 100%;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1;
}

#person-icon {
  width: 70px;
  padding: 10px;
  /* background-color: #fff; */
  border-radius: 50%;
  cursor: pointer;
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 999999;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1); */
}

#person-icon span {
  text-align: center;
  font-weight: bold;
  margin-left: 3px;
}

.ui.page.dimmer {
  background-color: rgba(0, 0, 0, 0) !important;
}

#popup-box-content {
  max-width: 1020px;
  min-width: 1020px;
  height: 620px;
  position: fixed;
  right: 20px;
  background-color: #fff;
  bottom: 80px;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1);
}

#popup-box-content-fullScreen {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 40px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1);
}

#popup-box-guide {
  max-width: 400px;
  min-width: 400px;
  height: 600px;
  position: absolute;
  left: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
}

.app-example {
  height: 60px;
  display: flex;
  align-items: center;
  background: rgb(226, 246, 237);
  justify-content: space-around;
}

.app-exaMain {
  width: 400px;
  height: calc(100% - 80px);
}

.app-exaMain /deep/ .el-carousel__container {
  height: 621px;
}

.app-exaMain /deep/ .el-carousel__button {
  background-color: #555;
}

.app-img {
  width: 400px;
  height: 620px;
}

#popup-box-data {
  max-width: 620px;
  min-width: 620px;
  height: 680px;
  position: absolute;
  right: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 0px rgba(0, 0, 0, 0.1);
}

#popup-box-data-fullScreen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 0px rgba(0, 0, 0, 0.1);
}

.popup-box-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding-left: 54px;
}
.popup-box-title-fullScreen {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding-left: 54px;
}

.app-close {
  height: 60px;
  display: flex;
  align-items: center;
  background: rgb(226, 246, 237);
  justify-content: space-between;
  box-shadow: -1px 0px 10px 0px rgba(159, 158, 158, 0.1);
}

.app-main {
  width: 620px;
  height: calc(100% - 60px);
}

.app-main-fullScreen {
  width: 100%;
  height: calc(100% - 60px);
}

@import "./styles/main.css";

.el-popper {
  /* left: 0!important; */
  /* right:200px!important; */
}

.ai-box {
  position: absolute;
  right: 20px;
  bottom: 100px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
}

.el-header {
  padding: 0 !important;
}

#container-box {
  min-height: 100%;
  background-color: #eff3f5 !important;
}

.el-main {
  color: #333;
  height: 100%;
  padding: 0 3% !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.remain {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #110b01;
  /* padding: 0px 30px; */
}

.amountArea {
  padding: 20px 40px 0px 40px;
  justify-content: space-around;
}

.wx-svg {
  display: inline-block;
  width: 160px;
  background: #f2f2f2;
  margin-top: 19px;
  padding: 6px 0 4px 4px;
  border-radius: 8px;
}

.radioLayout {
  display: flex !important;
  justify-content: space-between !important;
  border: none;
}

.radioLayout /deep/ .el-radio-button__inner:checked {
  color: #fff !important;
  background: linear-gradient(101.37deg, #fff9c6 1.05%, #ffe1c2 97.37%) !important;
  box-shadow: inset 0 0 0 2px #ffb66d !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff !important;
  background: linear-gradient(101.37deg, #fff9c6 1.05%, #ffe1c2 97.37%) !important;
  box-shadow: inset 0 0 0 2px #ffb66d !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner .lackAmount {
  background: linear-gradient(270deg, #f60, #ffa047) !important;
  color: #fff;
}

.radioLayout /deep/ .el-radio-button__inner {
  border: 0px;
  border-radius: 8px !important;
  height: 120px;
  width: 130px;
  padding: 12px 4px;
  color: #02a7f0;
  background-color: #f7f9fc;
}

.radioLayout /deep/ .el-radio-button__inner:checked {
  color: #fff !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked {
  color: #fff !important;
}

.month {
  text-align: center;
  font-size: 16px;
  color: #495366;
  margin-left: 2px;
  margin-top: 4px;
}

.amount {
  display: inline-block;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-left: -4px;
  color: #f60;
}

.realAmount {
  color: #030b1a;
  font-size: 12px;
  opacity: 0.3;
  margin-left: 8px;
  text-decoration: line-through;
}

.lackAmount {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 18px;
  background-color: #fff6e8;
  color: rgba(107, 45, 0, 0.6);
  border-radius: 0 0 7px 7px;
  width: 100%;
}

.recharge-area {
  margin-top: 20px;
  display: flex;
  height: 150px;
}

.actual-payment {
  font-size: 16px;
  font-weight: 700;
  margin: 20px 0 0 30px;
}

.actual-payment span {
  color: #02a7f0;
  font-size: 24px;
}

.radioLayout div {
  padding-top: 4px;
}

.pay-dialog-wx /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 750px;
}

.pay-dialog /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 900px;
}

.rechargeDialog /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 650px;
}

.rechargeDialog /deep/ .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
}

.rechargeDialog /deep/ .el-radio-button {
  border-radius: 6px !important;
}

.rechargeDialog /deep/ .el-dialog__header {
  background: #1076f6;
  color: #fff !important;
  border-radius: 10px 10px 0 0;
}

.rechargeDialog /deep/ .el-dialog__title {
  color: #fff !important;
}

.rechargeDialog /deep/ .el-dialog__close {
  color: #fff !important;
}

.qrcode {
  width: 120px;
  height: 120px;
}

.qrcode img {
  width: 120%;
  height: 120%;
}

.pay-result {
  padding: 0px !important;
}
</style>
